export const PERMS = {
    READ: 'user_logins.read',
    EXPORT: 'user_logins.export',
}
